module.exports = __webpack_public_path__ + "static/img/solution-slowfloat.9843199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solutions/solution-slowfloat.png
// module id = ut/K
// module chunks = 0